export const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-stone/50 px-6 py-16 text-center"
  >
    <img
      src="/assets/o-mark.jpeg"
      alt="ō"
      className="mx-auto h-12 w-12 rounded-full object-cover"
    />
    <p className="mt-6 font-garamond text-lg text-ink">syndeō</p>
    <p className="mt-2 font-oswald text-[10px] uppercase tracking-[0.4em] text-marine/60">
      Private Provider Intelligence
    </p>
  </footer>
);
